'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path')

const CDN_STATIC_DOMAIN = '//statics.classba.cn/'
const  FE_PUBLIC_APP_NAME = 'fe_public'//公共资源名
const APP_NAME = 'fe_supervise' // 项目名

const DEV_ENV = "development" // 开发
const TEST_ENV = "test" // 测试
const PRE_ENV = "pre" // 预发
const PROD_ENV = "prod" // 正式

if(!process.env.NODE_ENV)
{
  process.env.NODE_ENV = DEV_ENV
}


const APP_ENV = process.env.APP_ENV

let assetsPublicPath = CDN_STATIC_DOMAIN + "" + APP_ENV +"/" + APP_NAME
let cdnPath = CDN_STATIC_DOMAIN + "" + APP_ENV +"/" + FE_PUBLIC_APP_NAME


console.log(assetsPublicPath,'assetsPublicPath')


module.exports = {
  dev: {

    // Paths
    cdnPath,
    assetsSubDirectory: 'static',
    assetsPublicPath:'/',
    proxyTable: {
      '/api': {
        // target: 'http://supervisev3.be.dev.myyixue.com/', // 开发环境
        // target: 'http://192.168.30.153:8080/', // 本地联调环境
        target: 'http://supervise-v3.test.classba.cn/', // 测试环境
        // target: 'http://supervise-v3.classba.cn/', // 正式环境
        secure: false,
        changeOrigin: true,
      },
      // '/game': {
      //   target: 'http://test-mmath.classba.cn/',
      //   secure: false,
      //   changeOrigin: true,
      // }
    },

    // Various Dev Server settings
    host: 'localhost', // can be overwritten by process.env.HOST
    // host: '127.0.0.1', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: true,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-


    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },
  build: { // 正式环境
    // Template for index.html
    cdnPath,
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist/'),
    assetsSubDirectory: 'static',
    assetsPublicPath:assetsPublicPath + "/",

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}



// WEBPACK FOOTER //
// ./config/index.js